import autosize from 'autosize';

$(() => {
  //console.log("textarea.js");
  $('.autosizetext').keydown(function (event) {
    if (event.ctrlKey) {
      var textarea = event.target as HTMLTextAreaElement;
      var oldTxt = textarea.value;
      var selectionStart = textarea.selectionStart;
      var selectionEnd = textarea.selectionEnd;
      switch (event.key) {
        case 'b':
          var newTxt = oldTxt.substring(0, selectionStart);
          newTxt += '<b>' + oldTxt.substring(selectionStart, selectionEnd) + '</b>';
          newTxt += oldTxt.substring(selectionEnd);
          textarea.value = newTxt;
          textarea.setSelectionRange(selectionStart + 3, selectionEnd + 3);
          event.preventDefault();
          break;
        case 'i':
          var newTxt = oldTxt.substring(0, selectionStart);
          newTxt += '<i>' + oldTxt.substring(selectionStart, selectionEnd) + '</i>';
          newTxt += oldTxt.substring(selectionEnd);
          textarea.value = newTxt;
          textarea.setSelectionRange(selectionStart + 3, selectionEnd + 3);
          event.preventDefault();
          break;
        case 'l':
          var newTxt = oldTxt.substring(0, selectionStart);
          newTxt += '<a href="">' + oldTxt.substring(selectionStart, selectionEnd) + '</a>';
          newTxt += oldTxt.substring(selectionEnd);
          textarea.value = newTxt;
          textarea.setSelectionRange(selectionStart + 9, selectionStart + 9);
          event.preventDefault();
          break;
        case 'u':
          var newTxt = oldTxt.substring(0, selectionStart);
          newTxt += '<ul>' + oldTxt.substring(selectionStart, selectionEnd) + '</ul>';
          newTxt += oldTxt.substring(selectionEnd);
          textarea.value = newTxt;
          textarea.setSelectionRange(selectionStart + 4, selectionEnd + 4);
          event.preventDefault();
          break;
        case 'd':
          var newTxt = oldTxt.substring(0, selectionStart);
          newTxt += '<li>' + oldTxt.substring(selectionStart, selectionEnd) + '</li>';
          newTxt += oldTxt.substring(selectionEnd);
          textarea.value = newTxt;
          textarea.setSelectionRange(selectionStart + 4, selectionEnd + 4);
          event.preventDefault();
          break;
      }
      autosize.update(textarea);
    }
  });
});
